import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detalle-linea',
  templateUrl: './detalle-linea.component.html',
  styleUrls: ['./detalle-linea.component.scss']
})
export class DetalleLineaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
